/**
 * @deprecated This configuration has been moved to `@vts/client-config` library.
 * Please use `import { routes } from '@vts/client-config/lib/routes/userManagementRoutes'` instead.
 * This file will be removed in a future version.
 * @see {@link https://github.com/VTS-com/lane-next/tree/main/libs/client-config/src/lib/routes/userManagementRoutes.ts}
 */
export enum routes {
  UsersList = 'user-management/users',
  UsersInvite = 'user-management/users/invite',
  UsersInviteWithGroupRoleId = 'user-management/users/invite/:groupRoleId',
  UsersAdd = 'user-management/users/add',
  PermissionGroupsList = 'user-management/permission-groups',
  PermissionGroupView = 'user-management/permission-groups/:groupRoleId/view',
  PermissionGroupEdit = 'user-management/permission-groups/:groupRoleId/edit',
  PermissionGroupCreate = 'user-management/permission-groups/new',
  TeamsList = 'user-management/teams',
  TeamView = 'user-management/teams/:groupRoleId/view',
  TeamCreate = 'user-management/teams/new',
  TeamEdit = 'user-management/teams/:groupRoleId/edit',
}
